jQuery( function($){

    var $slider_string  = '.js-tabs';
    var $slider         = $($slider_string);

    $slider.each( function (i, el) {
        var $this               = $(el);
        var $count_slides        = $this.data('slick-slides');
        var $slider__nav       = $this.find($slider_string+'__nav');
        var $slider__slides     = $this.find($slider_string+'__slides');

        $slider__nav.slick({
            arrows: false,
            slidesToShow: $count_slides,
            slidesToScroll: 1,
            asNavFor: $slider__slides,
            focusOnSelect: true
        });
        $slider__slides.slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: $slider__nav,
            swipe: false,
            swipeToSlide: false,
            draggable: false
        });
    });

});
